import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
// metrics
import {metrics} from '~/vendor/metrics';
import {Button} from '@customink/pigment-react';

const propTypes = {
  dismiss: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class ShoppingCartConfirmEmptyNotification extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    dismiss() {}
  };

  componentDidMount() {
    metrics.pageViewTag('/ndx/cart');
    metrics.pageViewTag('/ndx/cart/empty');
  }

  cancel = () => {
    metrics.fireEvent('keep shopping modal', 'cart icon', 'return to lab');
    this.props.dismiss();
  };

  render() {
    return (
      <Notification
        dismiss={this.cancel}
        title="Your Cart is Empty"
        type="PROMPT">
        <p className="ndx-cta1">
          You can return to the lab if you wish to add to your cart.
        </p>
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={this.cancel}>
          Return to Design Lab
        </Button>
      </Notification>
    );
  }
}

ShoppingCartConfirmEmptyNotification.displayName =
  'ShoppingCartConfirmEmptyNotification';
